<template>
  <div class="d-default-exit-modal">
    <DExitModal
      id="exit-modal"
      data-modal-name="Exit modal example"
      :data-modal-test="test"
    >
      <template #modal-image>
        <img :src="image">
      </template>

      <template #modal-pre-body>
        <div class="discovery-logo-black" />
      </template>

      <template #modal-body>
        <h2>
          {{ header }}
        </h2>

        <h3 class="space-bottom-2em">
          {{ content }}
        </h3>

        <slot name="modal-body" />
      </template>
    </DExitModal>

    <DModalMobileAlert
      :content="header"
      event-name="open-sign-up-modal"
      :image-url="image"
      modal-id="exit-modal"
      :show-at-position="'100'"
      :show-only-on-scroll-up="true"
      :tracking-extra="trackingExtra"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import DExitModal from '@d-shared/components/exit-modals/d-exit-modal/d-exit-modal.vue';
import DModalMobileAlert from '@d-shared/components/exit-modals/d-modal-mobile-alert/d-modal-mobile-alert.vue';

export default {
  components: {
    DModalMobileAlert,
    DExitModal,
  },
  props: {
    content: {
      type: String,
      required: true,
    },
    header: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    test: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    trackingExtra: {
      label: 'submit-your-book',
      location: 'mobile-alert',
      method: 'email',
      type: 'button',
    },
  }),
};
</script>
